export const MemberVehicle = {
    id: '',
    memberId: '',
    policeNumber: '',
    brandId: '',
    brand: '',
    name: '',
    type: '',
    year: 0
}